module.exports = __webpack_public_path__ + "assets/img/RewardBodyBtn1.a011e3fd.png";